import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './payment-sips.component'

let module = angular.module('paymentSips', [
  uiRouter
])

.component('paymentSips', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/buy-product/payment-sips/index.js